import { TabList } from "@mui/lab";
import styled from "styled-components";

export const ScenarioBuilderStyledTabList = styled(TabList)`
 margin: 20px 20px 0 20px; 
`